class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.productContainer = document.getElementById('cart-notification-product');
    this.headingText = this.notification.querySelector('[data-tm-cart-heading-text]');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.pendingTimeout = 0;

    this.notification.addEventListener('keyup', (event) => event.code === 'Escape' && this.close());
    this.querySelectorAll('.cart-notification__close, .cart-notification__links > button.link').forEach((closeButton) => {
      closeButton.addEventListener('click', this.close.bind(this));
    });
  }

  showPending() {
    if (!this.notification || !this.productContainer) return;
    window.clearTimeout(this.pendingTimeout);
    this.pendingTimeout = window.setTimeout(() => this.cancelPending(), 12000);
    this.notification.dataset.tmPending = 'true';
    this.notification.setAttribute('aria-busy', 'true');
    if (this.headingText) this.headingText.textContent = this.headingText.dataset.pendingLabel || 'Adding to cart…';
    const pending = document.createElement('div');
    pending.className = 'tm-cart-notification-pending';
    pending.setAttribute('role', 'status');
    const indicator = document.createElement('span');
    indicator.setAttribute('aria-hidden', 'true');
    const label = document.createElement('span');
    label.textContent = this.headingText?.dataset.pendingLabel || 'Adding to cart…';
    pending.append(indicator, label);
    this.productContainer.replaceChildren(pending);
    this.open();
  }

  setReady() {
    window.clearTimeout(this.pendingTimeout);
    this.pendingTimeout = 0;
    delete this.notification.dataset.tmPending;
    this.notification.removeAttribute('aria-busy');
    if (this.headingText) this.headingText.textContent = this.headingText.dataset.readyLabel || 'Item added to your cart';
  }

  cancelPending() {
    if (this.notification.dataset.tmPending !== 'true') return;
    this.setReady();
    this.close();
  }

  open() {
    this.notification.classList.add('animate', 'active');
    document.body.classList.add('tm-cart-notification-open', 'overflow-hidden');
    window.cancelAnimationFrame(this.focusFrame);
    this.focusFrame = window.requestAnimationFrame(() => {
      if (!this.notification.isConnected || !this.notification.classList.contains('active')) return;
      this.notification.focus({ preventScroll: true });
      trapFocus(this.notification);
    });
    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    window.cancelAnimationFrame(this.focusFrame);
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
    document.body.classList.remove('tm-cart-notification-open');
    if (!document.querySelector('cart-drawer.drawer.active')) document.body.classList.remove('overflow-hidden');
    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.setReady();
    this.cartItemKey = parsedState.key;
    this.renderSections(parsedState.sections || {});
    window.__tmCartOfferTimer?.(this.notification);
    if (this.header) this.header.reveal();
    this.open();
  }

  renderSections(sections) {
    this.getSectionsToRender().forEach((section) => {
      const target = document.getElementById(section.id);
      const html = sections[section.id];
      if (!target || !html) return;
      const content = this.getSectionInnerHTML(html, section.selector);
      if (content !== null) target.innerHTML = content;
    });

    window.__tmWarmCheckout?.();
  }

  getSectionsToRender() {
    return [
      { id: 'cart-notification-product', selector: '.tm-cart-notification-list' },
      { id: 'cart-notification-button' },
      { id: 'cart-icon-bubble' },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const documentFragment = new DOMParser().parseFromString(html, 'text/html');
    return documentFragment.querySelector(selector)?.innerHTML ?? null;
  }

  handleBodyClick(event) {
    const target = event.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);

function tmWarmCheckout() {
  if (window.__tmCheckoutWarmStarted) return;
  window.__tmCheckoutWarmStarted = true;
  if (navigator.connection?.saveData) return;

  const head = document.head;
  if (!head) return;
  [
    { rel: 'preconnect', href: 'https://cdn.shopify.com', crossorigin: 'anonymous' },
    { rel: 'dns-prefetch', href: '//cdn.shopify.com' },
    { rel: 'preconnect', href: 'https://shop.app', crossorigin: 'anonymous' },
    { rel: 'dns-prefetch', href: '//shop.app' },
  ].forEach((definition) => {
    if (head.querySelector(`link[rel="${definition.rel}"][href="${definition.href}"]`)) return;
    const link = document.createElement('link');
    link.rel = definition.rel;
    link.href = definition.href;
    if (definition.crossorigin) link.crossOrigin = definition.crossorigin;
    head.appendChild(link);
  });
}

window.__tmWarmCheckout = window.__tmWarmCheckout || tmWarmCheckout;

window.__tmCartOfferTimer = window.__tmCartOfferTimer || (() => window.TMCartOfferReservation?.sync());
